import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkAllowScreenshare } from 'features/permissions/actions';

export function* bulkAllowScreenshareSaga(action: ReturnType<typeof bulkAllowScreenshare>) {
  const { roles, skipUsers } = action.payload;

  logger
    .remote({ action: true, tier: 1 })
    .info(`The user bulk allowed screenshare for roles=${roles.join(',')}`);

  yield call(SignalingSocket.send, {
    event: 'bulkAllowScreenshare',
    data: { roles, ...(skipUsers?.length ? { skipUsers } : {}) },
  });
}
